import React from "react";
import {Navigate, Outlet, useOutletContext} from 'react-router-dom';

type ContextType = {
    token: string,
    user: {
        role: 'CLIENT' | 'STAFF' | 'ADMIN',
        name: string,
    }
}

type ProtectedRouteProps = {
    scope: 'GUEST' | 'CLIENT' | 'STAFF' | 'ADMIN'
}

export const ProtectedRoute = (props: ProtectedRouteProps) => {
    const {scope: routeScope} = props

    const rawUser = localStorage.getItem("auth")

    const parsedUser: ContextType | undefined = rawUser ? JSON.parse(rawUser) : undefined

    if (parsedUser === undefined) {
        if (routeScope !== 'GUEST') {
            return <Navigate to="/login" replace />;
        }

        return <Outlet context={parsedUser} />;
    }

    switch (parsedUser.user.role) {
        case "CLIENT": {
            if (routeScope !== "CLIENT") {
                return <Navigate to="/my-application" replace />;
            }

            break;
        }

        case "STAFF": {
            if (routeScope !== "STAFF") {
                return <Navigate to="/leads" replace />;
            }

            break;
        }

        case "ADMIN": {
            if (routeScope !== "ADMIN" && routeScope !== "STAFF") {
                return <Navigate to="/leads" replace />;
            }

            break;
        }
    }

    return <Outlet context={parsedUser} />;
};

export const useUser = () => {
    return useOutletContext<ContextType>()
}
